import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './caps.scss';

class Caps extends Component {
  static propTypes = {
    link: PropTypes.string
  };

  render() {
    const link = this.props.link ? this.props.link : '#/todo';

    return (
      <a href={link} className="caps">
        {this.props.children}
      </a>
    );
  }
}

export default Caps;



// WEBPACK FOOTER //
// ./src/blocks/caps/Caps.js